<template>
    <div class="hp-landing-categories">
        <div class="wider-wrapper">
            <div class="hp-l-intro">
            <h2 class="hp-l-title">Katalog proizvoda</h2>
                <div class="hp-l-subtitle">Istražite našu ponudu proizvoda vrhunskih brandova</div>
            </div>
            <BaseCatalogCategoriesWidget :fetch="{level_range: '1.3', hierarhy_by_position: true, response_fields: ['id', 'code', 'children', 'url_without_domain', 'title']}" v-slot="{items}">
                <div v-if="items.length" class="hp-landing-cnt">
                    <div v-for="item in items" :key="item.id" :class="['cll', 'cll-'+item.code, item.children?.length && 'has-children', activeCategories.includes(item.id) && 'active']">
                        <BaseUiLink native :prevent-default="(item.children?.length && mobileBreakpoint) ? true : false" :href="item.url_without_domain" @click="toggleActive(item.id)" class="cll-title" v-if="item.title && item.url_without_domain">
                            {{item.title}}
                            <span v-if="item.children?.length" class="toggle-icon"></span>
                        </BaseUiLink>

                        <div v-if="item.children?.length" class="cll-main-cnt">
                            <ul class="cll-main-ul">
                                <li v-for="subcategory in item.children" :key="subcategory.id">
                                    <NuxtLink :to="subcategory.url_without_domain" v-if="subcategory.url_without_domain && subcategory.title">{{subcategory.title}}</NuxtLink>
                                </li>
                                <li v-if="item.url_without_domain"><NuxtLink :to="item.url_without_domain+'?searchcode=basic&searchid=2&sort=new&new=1&search_q='" class="c-new"><BaseCmsLabel code="category_new" /></NuxtLink></li>              
                                <li v-if="item.url_without_domain"><NuxtLink :to="item.url_without_domain+'?searchcode=basic&searchid=2&discount=1'" class="c-discount"><BaseCmsLabel code="discounted_products" /></NuxtLink></li>                        
                                <li v-if="item.url_without_domain"><NuxtLink :to="item.url_without_domain" class="c-discount"><BaseCmsLabel code="show_all" /></NuxtLink></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </BaseCatalogCategoriesWidget>
        </div>
    </div>		
</template>

<script setup>
	const {mobileBreakpoint} = inject('rwd');
	const activeCategories = ref([]);    
	
    function toggleActive(id) {
        if (activeCategories.value.includes(id)) {
            return activeCategories.value = activeCategories.value.filter(activeId => activeId !== id);
        }

        activeCategories.value.push(id);
	};
</script>

<style lang="less" scoped>
    .hp-landing-categories{background: url(assets/images/sitemap-bg.jpg) top left no-repeat; background-size: cover; padding: 100px 0; content-visibility: auto; contain-intrinsic-size: 1043px;}
    .hp-landing-cnt{display: block; column-count: 4;}
    .hp-l-intro{padding-bottom: 40px; text-align: center; color: white;}
    .hp-l-title{padding-top: 0; font-size: 42px; line-height: 54px; padding-bottom: 10px; font-weight: 500;}
    .hp-l-subtitle{font-size: 20px; line-height: 28px; font-weight: normal;}
    .cll-main-ul{
        list-style-type: none;
        a{color: white; text-decoration: none;}
        li{
            a{font-size: 18px; line-height: 26px; padding-bottom: 4px;
                @media(min-width: @h){
                    &:hover{text-decoration: underline;}
                }
            }
        }
    }
    .cll-title{color: white; text-decoration: none; font-size: 28px; line-height: 36px; text-transform: lowercase; display: inline-block; padding-bottom: 10px;
        &:first-letter{text-transform: uppercase;}
        @media(min-width: @h){
            &:hover{text-decoration: underline; color: white;}
        }
        .toggle-icon{display: none;}
    }
    .cll{padding-left: 54px; position: relative;
        &:before{.pseudo(auto,auto); left: 0; top: 0; .icon-patches; font: 32px/32px var(--fonti); color: white;}
    }
    .cll-zdr{margin-bottom: 30px;}
    .cll-dermokozmetika{
        margin-bottom: 30px;
        &:before{.icon-dermacosmetic; font: 36px/36px var(--fonti); top: -2px;}	
    }
    .cll-kozm{display: inline-block; margin-bottom: 36px;
        &:before{.icon-skin-care; font: 36px/36px var(--fonti); top: -2px;}
    }
    .cll-medpom{
        margin-bottom: 37px;
        &:before{.icon-medicine; font: 36px/36px var(--fonti); }
    }
    .cll-1370{
        display: inline-block; margin-bottom: 37px;	
        &:before{.icon-mother; font: 36px/36px var(--fonti);}
    }
    .cll-pos{
        &:before{.icon-favorites; font: 35px/35px var(--fonti);}
        .c-new,.c-discount,.c-all{display: none;}
    }
    .c-new,.c-discount,.c-all{font-weight: bold;}

    @media (max-width: @l){
        .hp-landing-categories{padding: 80px 0;}
        .cll{padding-left: 45px;}
        .cll-title{font-size: 25px; line-height: 32px; padding-bottom: 8px;}
        .cll:before{font: 32px/32px var(--fonti);}
        .cll-2:before{font: 33px/33px var(--fonti);}
        .cll-3:before{font: 32px/32px var(--fonti);}
        .cll-4:before{font: 34px/34px var(--fonti);}
        .cll-5:before{font: 32px/32px var(--fonti);}
    }

    @media (max-width: @t){
        .hp-landing-categories{padding: 50px 0;}
        .hp-l-title{font-size: 32px; line-height: 42px; padding-bottom: 8px;}
        .hp-l-subtitle{font-size: 16px; line-height: 24px;}
        .hp-l-intro{padding-bottom: 30px;}
        .cll-title{font-size: 20px; line-height: 26px; padding-bottom: 8px;}
        .cll{padding-left: 38px;
            &:before{font: 28px/28px var(--fonti);}
        }
        .cll-2{
            &:before{font: 30px/30px var(--fonti); top: 0;}
        }
        .cll-3{
            &:before{font: 28px/28px var(--fonti); top: 2px;}
        }
        .cll-4{
            &:before{font: 28px/28px var(--fonti); top: 2px;}
        }
        .cll-4{
            &:before{font: 26px/26px var(--fonti); top: 4px;}
        }
        .cll-main-ul{
            li{font-size: 15px; line-height: 25px;
                a{font-size: 15px; line-height: 25px;}
            }
        }        
    }

    @media (max-width: @tp){
        .hp-landing-categories{padding: 0;
            .wider-wrapper{margin: 0;}
        }
        .hp-l-intro{padding-bottom: 15px; padding-left: 15px; padding-right: 15px; padding-top: 35px;}
        .hp-l-title{font-size: 24px; line-height: 32px; padding-bottom: 6px;}
        .hp-l-subtitle{font-size: 14px; line-height: 20px;}
        .hp-landing-cnt{display: block; column-count: unset;}
        .cll-main-cnt{display: none;}
        .cll-main-ul li a{padding-bottom: 0;}
        .cll{border-top: 1px solid rgba(255,255,255,0.2); border-bottom: 1px solid rgba(255,255,255,0.2); margin: 0; margin-top: -1px; display: block; padding-left: 47px;
            &:before{font: 19px/19px var(--fonti); left: 15px; top: 15px;}
            &.active{padding-bottom: 15px;
                .cll-main-cnt{display: block;}
                .cll-title{padding-bottom: 7px;}
                .toggle-icon{
                    &:before{display: none;}
                }
            }
        }
        .cll-2{
            &:before{font: 20px/20px var(--fonti); top: 15px}
        }
        .cll-3{
            &:before{font: 20px/20px var(--fonti); top: 13px;}
        }
        .cll-4{
            &:before{font: 20px/20px var(--fonti); top: 15px;}
        }
        .cll-5{
            &:before{font: 18px/18px var(--fonti); top: 15px;}
        }
        .cll-title{font-size: 16px; line-height: 21px; font-weight: normal; text-decoration: none !important; display: block; padding: 14px 40px 14px 0;
            .toggle-icon{display: block; right: 15px; top: 19px; position: absolute;
                &:before,&:after{background: white;}
            }
        }        
    }
    @media (max-width: @m){
        .hp-l-intro{text-align: left; padding: 24px 15px 15px;}
        .hp-l-title{padding-bottom: 3px;}
        .hp-l-subtitle{font-size: 18px; line-height: 21px; padding-right: 20px;}
        .cll-title{font-size: 18px;}
    }
</style>